// mathNode.js

import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const MathNode = ({ id, data }) => {
    const [operation, setOperation] = useState(data?.operation || 'add');

    return (
        <BaseNode
            id={id}
            title="Math Node"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-a`, style: { top: '33%' } },
                { type: 'target', position: Position.Left, id: `${id}-b`, style: { top: '66%' } },
                { type: 'source', position: Position.Right, id: `${id}-result` }
            ]}
        >
            <label style={{ display: 'flex', flexDirection: 'column', fontSize: '12px' }}>
                Operation:
                <select value={operation} onChange={(e) => setOperation(e.target.value)} style={{ marginTop: '4px' }}>
                    <option value="add">Add (+)</option>
                    <option value="subtract">Subtract (-)</option>
                    <option value="multiply">Multiply (*)</option>
                    <option value="divide">Divide (/)</option>
                </select>
            </label>
        </BaseNode>
    );
}
